<template>
  <!-- <div style="width:50px; height:30px; background-color:red; position: absolute; z-index:1000;" @click="chag"></div>  -->

  <router-view v-slot="{Component}">
    <component ref="myRouterView" :is="Component" />
  </router-view>
  <!-- <router-view ref="myRouterView"></router-view> -->
</template>
<script>
import startkiosk_cafe from '@/js/data/cafe/startkiosk';
import posconfig_cafe from '@/js/data/cafe/posconfig';

import startkiosk_food from '@/js/data/food/startkiosk';
import posconfig_food from '@/js/data/food/posconfig';

import i18n from './i18n';
import {ref} from 'vue';

export default {
  name: 'app',
  data() {
    return {
      product: null,
      posConfig: null,
      kioskSettingTimer: null,
      errMsg: '',
      flag: 1,
      settingType: this.$store.getters.getSettingType,
      myRouterView: false,
    };
  },
  methods: {
    chag(barcode) {
      if (this.$refs.myRouterView != null) this.$refs.myRouterView.getItemDetail(barcode);
    },
    async renewal(type) {
      await this.$store.dispatch('setPosConfig', posconfig.data);
      await this.$store.dispatch('setMasterData');
      await this.$store.dispatch('setTbMstOpt');
      await this.$store.dispatch('setTbMstItem');
      await this.$store.dispatch('setKioskItem');
      await this.$store.dispatch('setAllergys');
      await this.$store.dispatch('setRecommendItem');
      await this.$store.dispatch('setReceiptDiscount');
      await this.$store.dispatch('setCurrencyUnit', posconfig.data.posConfig.currencyUnit);
    },
    // 대기화면 이동시간 초기화
    reselIdle() {
      this.$store.dispatch('resetIdle');
    },
    // 키오스크 기본 정보 동기화
    async kioskReady() {
      let posconfig = null;
      if (this.settingType == 1) posconfig = posconfig_cafe;
      else if (this.settingType == 2) posconfig = posconfig_food;
      else if (this.settingType == 3) posconfig = posconfig_food;

      await this.$store.dispatch('setPosConfig', posconfig.data);
      await this.$store.dispatch('setMasterData');
      await this.$store.dispatch('setTbMstOpt');
      await this.$store.dispatch('setTbMstItem');
      await this.$store.dispatch('setKioskItem');
      await this.$store.dispatch('setAllergys');
      await this.$store.dispatch('setRecommendItem');
      await this.$store.dispatch('setReceiptDiscount');
      await this.$store.dispatch('setCurrencyUnit', posconfig.data.posConfig.currencyUnit);

      this.kioskPosConfig(posconfig.data);
    },
    // 키오스크 setting 및 로그인 체크
    kioskPosConfig(posConfig) {
      this.posConfig = posConfig;

      this.styleSetting(); //style setting
      this.languageSetting(); // language setting
      this.$router.replace({path: '/user/idle'});

      document.addEventListener('mousedown', this.reselIdle);
    },
    languageSetting() {
      if (typeof this.$i18n == 'undefined') {
        setTimeout(() => {
          this.languageSetting();
        }, 100);
      } else {
        if (this.posConfig.posConfig.defaultLanguage == 'KO') this.$i18n.locale = 'ko';
        else if (this.posConfig.posConfig.defaultLanguage == 'JP') this.$i18n.locale = 'jp';
        else if (this.posConfig.posConfig.defaultLanguage == 'EN') this.$i18n.locale = 'en';
        else if (this.posConfig.posConfig.defaultLanguage == 'CH') this.$i18n.locale = 'cn';
        else if (this.posConfig.posConfig.defaultLanguage == 'TW') this.$i18n.locale = 'tw';
      }
    },
    styleSetting() {
      // let mainHighlightColor = this.posConfig.posConfig.mainHighlightColor;
      // let subHighlightColor = this.posConfig.posConfig.subHighlightColor;
      // let mainFontColor = this.posConfig.posConfig.mainFontColor;
      // let subFontColor = this.posConfig.posConfig.subFontColor;
      // let backgroundColor = this.posConfig.posConfig.backgroundColor;

      // mainHighlightColor = mainHighlightColor == '' || mainHighlightColor == null ? '#ff3331' : mainHighlightColor;
      // subHighlightColor = subHighlightColor == '' || subHighlightColor == null ? '#490171' : subHighlightColor;
      // mainFontColor = mainFontColor == '' || mainFontColor == null ? '#ffffff' : mainFontColor;
      // subFontColor = subFontColor == '' || subFontColor == null ? '#7418ee' : subFontColor;
      // backgroundColor = backgroundColor == '' || backgroundColor == null ? '#ffffff' : backgroundColor;

      let mainHighlightColor = '#F9BB02';
      let subHighlightColor = '#121D2A';
      let mainFontColor = '#36343E';
      let subFontColor = '#2E4871';
      let backgroundColor = '#FFFFFF';

      let backgroundColorR = parseInt(backgroundColor.slice(1, 3), 16),
        backgroundColorG = parseInt(backgroundColor.slice(3, 5), 16),
        backgroundColorB = parseInt(backgroundColor.slice(5, 7), 16);

      document.documentElement.style.setProperty('--primary-color', mainHighlightColor);
      document.documentElement.style.setProperty('--secondary-color', subHighlightColor);
      document.documentElement.style.setProperty('--primary-ft-color', mainFontColor);
      document.documentElement.style.setProperty('--secondary-ft-color', subFontColor);
      document.documentElement.style.setProperty('--cust-back-color', backgroundColor);
      document.documentElement.style.setProperty('--cust-back-color-r', backgroundColorR);
      document.documentElement.style.setProperty('--cust-back-color-g', backgroundColorG);
      document.documentElement.style.setProperty('--cust-back-color-b', backgroundColorB);
      console.log('style setting');

      var style = document.createElement('style');
      style.innerHTML = `.btn-intro--w .txt { color: #FFFFFF !important; }`;
      document.head.appendChild(style);
    },
    styleCustomSetting(type) {
      let mainHighlightColor = this.posConfig.posConfig.mainHighlightColor; // 대표 버튼색깔
      let subHighlightColor = this.posConfig.posConfig.subHighlightColor; // 서브 버튼 ( order페이지 상단 메뉴 선택 시 강조색깔 )
      let mainFontColor = this.posConfig.posConfig.mainFontColor; // 메인 폰트 색깔
      let subFontColor = this.posConfig.posConfig.subFontColor; // 서브 폰트 강조색깔
      let backgroundColor = this.posConfig.posConfig.backgroundColor; // idle,order 배경색깔

      if (type == 'colortype1') {
        mainHighlightColor = '#F9BB02';
        subHighlightColor = '#121D2A';
        mainFontColor = '#36343E';
        subFontColor = '#2E4871';
        backgroundColor = '#FFFFFF';
      } else if (type == 'colortype2') {
        mainHighlightColor = '#F08B4B';
        subHighlightColor = '#92B460';
        mainFontColor = '#36343E';
        subFontColor = '#7FAD3B';
        backgroundColor = '#FFFFFF';
      } else if (type == 'colortype3') {
        mainHighlightColor = '#2F90A2';
        subHighlightColor = '#5B5D5D';
        mainFontColor = '#36343E';
        subFontColor = '#2F90A2';
        backgroundColor = '#FFFFFF';
      }
      // else if(type == 'colortype4'){
      //   mainHighlightColor  = '#f00022';
      //   subHighlightColor   = '#f00022';
      //   mainFontColor       = '#fffdbf';
      //   subFontColor        = '#f00022';
      //   backgroundColor     = 'white';
      // }

      mainHighlightColor = mainHighlightColor == '' || mainHighlightColor == null ? '#ff3331' : mainHighlightColor;
      subHighlightColor = subHighlightColor == '' || subHighlightColor == null ? '#490171' : subHighlightColor;
      mainFontColor = mainFontColor == '' || mainFontColor == null ? '#ffffff' : mainFontColor;
      subFontColor = subFontColor == '' || subFontColor == null ? '#7418ee' : subFontColor;
      backgroundColor = backgroundColor == '' || backgroundColor == null ? '#ffffff' : backgroundColor;

      let backgroundColorR = parseInt(backgroundColor.slice(1, 3), 16),
        backgroundColorG = parseInt(backgroundColor.slice(3, 5), 16),
        backgroundColorB = parseInt(backgroundColor.slice(5, 7), 16);

      document.documentElement.style.setProperty('--primary-color', mainHighlightColor);
      document.documentElement.style.setProperty('--secondary-color', subHighlightColor);
      document.documentElement.style.setProperty('--primary-ft-color', mainFontColor);
      document.documentElement.style.setProperty('--secondary-ft-color', subFontColor);
      document.documentElement.style.setProperty('--cust-back-color', backgroundColor);
      document.documentElement.style.setProperty('--cust-back-color-r', backgroundColorR);
      document.documentElement.style.setProperty('--cust-back-color-g', backgroundColorG);
      document.documentElement.style.setProperty('--cust-back-color-b', backgroundColorB);

      var style = document.createElement('style');
      style.innerHTML = `.btn-intro--w .txt { color: #FFFFFF !important; }`;
      document.head.appendChild(style);

      console.log(`styleCustomSetting setting`);
    },
  },
  async beforeCreate() {
    // this.$store.dispatch('setProduct');
  },
  async create() {},
  async mounted() {
    let startkiosk = null;
    if (this.settingType == 1) startkiosk = startkiosk_cafe;
    else if (this.settingType == 2) startkiosk = startkiosk_food;
    else if (this.settingType == 3) startkiosk = startkiosk_food;

    this.$store.dispatch('setIsSimpleToken', startkiosk.data.IS_SIMPLE_TOKEN === 'Y');
    this.$store.dispatch('setShopId', startkiosk.data.SHOP_ID);
    this.$store.dispatch('setStoreCd', startkiosk.data.STORE_CD);
    this.$store.dispatch('setCpCd', startkiosk.data.CP_CD);
    this.$store.dispatch('setPosNo', startkiosk.data.POS_NO);
    this.kioskReady();
    // iframe에서 보내는 message 처리
    window.onmessage = (event) => {
      // 색깔 변경
      if (event.data == 'colortype1' || event.data == 'colortype2' || event.data == 'colortype3' || event.data == 'colortype4') {
        this.styleCustomSetting(event.data);
      } else if (event.data == 'return') this.styleSetting();
      else if (event.data == 'type1' || event.data == 'type2' || event.data == 'type3') {
        let type = 1;
        if (event.data == 'type2') type = 2;
        else if (event.data == 'type3') type = 3;
        this.$store.dispatch('setSettingType', type);
        this.$router.replace({path: '/setting/data'});
      } else if (
        event.data.type != 'webpackOk' &&
        event.data.type != 'webpackClose' &&
        event.data.type != 'webpackProgress' &&
        event.data.indexOf('sco') >= 0
      ) {
        let barcode = event.data.replace('sco', '');
        this.chag(barcode);
      } else if (event.data == 'kr' || event.data == 'en' || event.data == 'jp') {
        let language = event.data == 'kr' ? 'ko' : event.data;
        i18n.global.locale = language;
        // this.$store.dispatch('setDefaultLanguage', language.toLocaleUpperCase());
        // this.posConfig.posConfig.defaultLanguage = language.toLocaleUpperCase();
      }
    };
  },
  async created() {},
  components: {},
  watch: {
    $route(to, from) {
      if (to.path == '/user/order') {
        window.onmessage = (event) => {
          // 색깔 변경
          if (event.data == 'colortype1' || event.data == 'colortype2' || event.data == 'colortype3' || event.data == 'colortype4') {
            this.styleCustomSetting(event.data);
          } else if (event.data == 'return') this.styleSetting();
          else if (event.data == 'type1' || event.data == 'type2' || event.data == 'type3') {
            let type = 1;
            if (event.data == 'type2') type = 2;
            else if (event.data == 'type3') type = 3;
            this.$store.dispatch('setSettingType', type);
            this.$router.replace({path: '/setting/data'});
          } else if (
            event.data.type != 'webpackOk' &&
            event.data.type != 'webpackClose' &&
            event.data.type != 'webpackProgress' &&
            event.data.indexOf('sco') >= 0
          ) {
            let barcode = event.data.replace('sco', '');
            this.chag(barcode);
          } else if (event.data == 'kr' || event.data == 'en' || event.data == 'jp') {
            let language = event.data == 'kr' ? 'ko' : event.data;
            i18n.global.locale = language;
            // this.$store.dispatch('setDefaultLanguage', language.toLocaleUpperCase());
            // this.posConfig.posConfig.defaultLanguage = language.toLocaleUpperCase();
          }
        };
      }
      this.adminPageYn = to.path.indexOf('admin') > 0 ? true : false;
    },
  },
};
</script>

<style>
@media (-webkit-device-pixel-ratio: 1.25) {
  .bottom-area--row {
    margin: 0 2em !important;
  }
  .btn-bottom-fix {
    zoom: 0.8 !important;
  }

  img {
    zoom: 0.8;
  }

  .dimed {
    width: 100vw !important;
  }
  .lyr-right {
    margin: 0px 6em 0em 7em !important;
  }
  .coupon-date {
    font-size: 0.8em !important;
    width: 51% !important;
  }
  .coupon-discount {
    font-size: 1.4em !important;
    width: 49% !important;
  }
  .main__footer {
    position: relative !important;
  }
  .menu__item {
    margin: 1.7vh 0 !important;
  }
  .helper-bottom-fix {
    top: 94.8vh !important;
  }

  .ft--lg,
  .touchbox-wrap,
  .total-price,
  .table-area,
  .btn,
  .main.sco {
    zoom: 0.8 !important;
  }

  .sco .content {
    height: 77vh !important;
  }

  .sco .content .cart-lst {
    height: 60vh !important;
    width: 108vw !important;
  }
  .sco .main__footer .total-area {
    width: 60% !important;
  }
  .sco .main__footer .btn-area {
    width: 38% !important;
  }
  .sco .main__footer .btn-area button {
    zoom: 1 !important;
  }
  .sco .preset-area {
    height: 16vh !important;
  }
  .sco .main__footer .box-gray.no-btn:last-child {
    height: 20vh !important;
  }
  .sco .btn--rnd-lg {
    height: 21em !important;
  }

  .sco .content .cart-lst .scroll-area,
  .sco .content .cart-lst .w-box-row.on {
    width: 100% !important;
  }

  .sco .content .cart-lst .scroll-area {
    height: 54.5vh !important;
  }
}

@keyframes rotateProgress {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.progress-icon-wrap {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}

.progress-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -8.9vw;
  margin-top: -8.9vw;
  width: 17.8vw;
  height: 17.8vw;
  background: url('@/assets/images/common/progress-image.png') no-repeat;
  background-size: 100% auto;
  animation: rotateProgress 1s infinite;
  z-index: 9999;
}

.loading {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 9999;
  text-align: center;
  padding: 50em 0px;
  background: #ffffff;
}

.loadingMsg {
  font-size: 40px;
  font-weight: bold;
  font-family: NotoSansKR;
}

.retbtn {
  width: 200px;
  height: 60px;
  margin-top: 50px;
  background-color: #ff5656;
  color: white;
  font-size: 24px;
  font-weight: bold;
}

.disp_off {
  display: none;
}

.disp_on {
  display: inline-block;
}
</style>

